export const MACHINES_NAMESPACE = "machines";
